import { TextKey } from '@mews-commander/enums';
import { useAppConfiguration } from '@mews-commander/data-access';
import { GDProduct, GoodDataDashboard } from '@mews-framework/good-data';
import { useGoodDataParameters } from '@mews-commander/reporting-framework';
import { GOOD_DATA_DASHBOARD_IDS } from './GoodDataDashboardIds';

const activeTabToGoodDataDashboardId = {
    [TextKey.DepositLedger]: GOOD_DATA_DASHBOARD_IDS.DEPOSIT_LEDGER,
    [TextKey.GuestLedger]: GOOD_DATA_DASHBOARD_IDS.GUEST_LEDGER,
    [TextKey.CityLedger]: GOOD_DATA_DASHBOARD_IDS.CITY_LEDGER,
};

export const LedgersView: React.FC<{
    activeTab: TextKey.DepositLedger | TextKey.GuestLedger | TextKey.CityLedger;
}> = ({ activeTab }) => {
    const goodDataDashboardId = activeTabToGoodDataDashboardId[activeTab];
    const { data } = useGoodDataParameters();
    const { environment } = useAppConfiguration();

    return (
        <GoodDataDashboard
            dashboard={goodDataDashboardId}
            environment={environment}
            goodDataParameters={data}
            product={GDProduct.Internal}
        />
    );
};
